/**
 * Normaliza la tasa de cambio recibida de la API o del input a número o null.
 */
export const parseExchangeRateValue = (value: string | number | null | undefined): number | null => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsedValue = Number(value);
  return Number.isNaN(parsedValue) ? null : parsedValue;
};
